<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/?page=timesheets"></top-nav-bar>

        <div v-if="loading" class="h-full flex items-center justify-center pt-24">
            <div class="spinner-blue"></div>
        </div>

        <template v-if="!loading && entry">
            <form v-if="!entry.id || entry.is_editable"
                  class="max-w-sm mx-auto px-4 overflow-y-auto pb-16 md:pb-0 py-2"
                  @submit.prevent="save">
                <h3 v-if="!entry.id" class="text-center mb-8">Add Timesheet Entry</h3>
                <h3 v-else class="text-center mb-8">Update Timesheet Entry</h3>

                <timesheets-form ref="timesheetsForm" v-model="entry"></timesheets-form>

                <button class="btn btn--colored__blue w-full"
                        :disabled="disabled"
                        :class="{'disabled': disabled}"
                        type="submit">
                    <i class="fal fa-spin fa-circle-notch" v-if="disabled"></i>
                    Save
                </button>
            </form>

            <div v-if="entry.id && !entry.is_editable"
                 class="py-10 text-center">
                <i class="fal fa-exclamation-triangle"></i>
                Only rejected or pending entries may be edited
            </div>
        </template>
    </div>
</template>

<script>
    import TimesheetsForm from '@/partials/TimesheetsForm.vue';
    import CanAccessView from '../mixins/CanAccessView';
    import moment from "moment";

    export default {
        mixins: [CanAccessView],
        components: {
            TimesheetsForm
        },

        data() {
            return {
                entry: null,
                disabled: false,
                loading: false,
            }
        },

        mounted() {
            this.getEntries();
        },

        methods: {
            getEntries() {
                this.loading = true;
                this.$api('timesheets').get('', {
                    params: {
                        period: moment(this.$route.params.date, 'YYYY-MM-DD').format('YYYY-MM')
                    }
                }).then(({data}) => {
                    let entry = {
                        id: null,
                        date: this.$route.params.date,
                        intervals: [{start: null, end: null}],
                        rest_day: false,
                        status: null,
                    }

                    const entryData = data.data.find(item => item.date === entry.date);

                    if (!!entryData) {
                        entry = entryData;
                    }

                    this.entry = entry;

                    this.loading = false;
                });
            },

            save() {
                if (this.disabled) {
                    return;
                }

                this.$store.commit('clearErrors');
                this.disabled = true;

                const data = this.$refs.timesheetsForm.save();

                this.$api('timesheets')
                    .post((this.entry.id ? `/${this.entry.id}` : ''), data)
                    .then(() => {
                        this.$router.replace('/timesheets');
                    })
                    .catch(error => {
                        this.$noty.error('An error occurred');
                    })
                    .finally(() => this.disabled = false);
            }
        },

        watch: {
            '$route'(to, from) {
                this.getEntries();
            }
        },
    }
</script>
